export { mediaStore, createMediaStore } from './store';